import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { modalConfig, ModalEnum } from 'src/app/core/util/modalConfig';
import { GenericUploadPictureModalComponent } from '../../modal/generic-upload-picture-modal/generic-upload-picture-modal.component';

@Component({
  selector: 'app-floating-upload-button',
  templateUrl: './floating-upload-button.component.html',
  styleUrl: './floating-upload-button.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FloatingUploadButtonComponent {
  isUploadDropdownOpen = false;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onAddComment = new EventEmitter<any>();
  uploadOptions: any = [
    {id: 1, name: 'Fotobibliotheek', icon: "uil uil-scenery"},
    {id: 2, name: 'Maak foto of neem video op', icon: "uil uil-camera"},
    {id: 3, name: 'Kies bestanden', icon: "uil uil-folder-open"},
    {id: 4, name: 'Google Drive', icon: "uil uil-google-drive-alt"},
  ]

  constructor(
    private dialog: MatDialog
  ){
    // avoid empty constructor
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }


  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert('Please select a valid image file.');
      return;
    }

    // Pass selected file to the modal
    this.openUploadModal(file);
  }
  
  openUploadModal(file: File): void {
    this.dialog.open(GenericUploadPictureModalComponent, modalConfig({
      data: { file },
      disableClose: true,
      closeOnNavigation: true,
      panelClass: ['customized-dialog-container', 'floating-upload-modal'],
    }, ModalEnum.ModalSmall)).afterClosed().subscribe((comment) => {
      if (comment?.msg && comment?.msg?.description?.trim().length) {
        const file = comment.fileUploadData;
        let htmlMessage = '';
        if (file && file.id && file.name) {
          htmlMessage = `
            <a 
              class="blue-text d-cursor-hand items-mentions" 
              target="${file.id}" 
              type="documents" 
              title="${file.name}">
              ${file.name}
            </a>
            <span id="${file.id}_documents_">
              &nbsp;${comment.msg.description || ''}
            </span>
          `.trim();
        } else {
          htmlMessage = comment.msg.description;
        }

        const msg = {
          collaborator: [],
          item: [{
                "id": file.id,
                "name": file.name,
                "type": "documents",
                "url": file.path,
                "code": "",
                "item": true,
                "title_name": `${file.name} (documents)`
            }],
          message: htmlMessage.trim()
        };
        this.onAddComment.emit(msg);
      }
    });
  }
}
